export function loadingRequestMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      loadingRequestId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateLoadingRequestId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateLoadingRequestId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyLoadingRequest(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      loadingRequestId: resource.objectId,
    })),
  };
}

export function loadingRequestMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, loadingRequestId: json.result.objectId},
  };
}